



















































































































































































import {
  computed,
  ref,
  defineComponent,
  reactive,
  watch,
  getCurrentInstance,
  ComponentInternalInstance,
} from '@vue/composition-api';
import {
  HelpCircleIcon,
  SettingIcon,
  ChevronLeftIcon,
  LockOnIcon,
  LoadingIcon,
  FileCopyIcon,
  CheckCircleFilledIcon,
  ErrorCircleFilledIcon,
} from 'tdesign-icons-vue';
import _ from 'lodash';
import { encode } from 'js-base64';
import RemoveConfigConfirm from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/RemoveConfigConfirm.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import { OpenLdapProtocol, OpenLdapProtocolFormData } from '@/renderer/scripts/libs/smh-sdk-class/typings';
import { copyText2Clipboard } from '@/renderer/scripts/utils/tools/index';
import tips from '@/renderer/scripts/utils/tips';

export default defineComponent({
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    initData: {
      requred: true,
      type: Object,
      default: () => {
        return {
          type: 'windowsAd',
          protocol: 'ldap',
          hostname: '',
          port: '',
          bindDN: '',
          bindPassword: '',
          searchDN: '',
          loginFlag: '',
          loginFlagShow: '',
          departmentObjectclass: '',
          userObjectclass: '',
        };
      },
    },
    testResult: {
      type: String,
      required: true,
      default: '',
    },
    testDetail: {
      type: Object,
      required: true,
      default: () => {
        return {
          departmentCount: 0,
          userCount: 0,
        };
      },
    },
  },
  components: {
    HelpCircleIcon,
    SettingIcon,
    ChevronLeftIcon,
    LockOnIcon,
    LoadingIcon,
    FileCopyIcon,
    CheckCircleFilledIcon,
    ErrorCircleFilledIcon,
    RemoveConfigConfirm,
  },
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });

    const defaultLoginFlag = props.initData.type === 'windowsAd' ? 'sAMAccountName' : 'uid';

    const ldapFormData = reactive<any>({
      type: 'windowsAd',
      protocol: 'ldap',
      hostname: '',
      port: '',
      bindDN: '',
      bindPassword: '',
      searchDN: '',
      departmentObjectclass: '',
      userObjectclass: '',
      loginFlag: defaultLoginFlag,
      loginFlagShow: '',
    });

    const ldapData = reactive<OpenLdapProtocol>({
      url: '',
      bindDN: '',
      bindPassword: '',
      searchDN: '',
      departmentObjectclass: '',
      userObjectclass: '',
      loginFlag: defaultLoginFlag,
      loginFlagShow: '',
    });
    const ldapOptions = [
      { label: 'ldap', value: 'ldap' },
      { label: 'ldaps', value: 'ldaps' },
    ];

    const defaultPort: { [key: string]: string } = {
      ldap: '389',
      ldaps: '636',
    };
    const inputChange = computed(
      () =>
        !_.isEqual(ldapFormData.departmentObjectclass, props.initData.departmentObjectclass) ||
        !_.isEqual(ldapFormData.userObjectclass, props.initData.userObjectclass),
    );

    const isCreate = computed(() => Object.keys(props.initData).some(key => _.isEmpty(props.initData[key])));
    const canTest = computed(
      () => Object.keys(ldapFormData).every(key => !_.isEmpty(ldapFormData[key])) && props.testResult !== 'testing',
    );
    const isChangePassword = ref(false);

    const showConfirm = ref(false);
    const ipReg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;

    const rules = {
      hostname: [
        {
          required: true,
          message: i18n_t('必填'),
          type: 'error',
        },
        {
          validator: (val: string) => ipReg.test(val),
          message: i18n_t('请输入正确的ip地址'),
          type: 'error',
        },
      ],

      port: [
        {
          required: true,
          message: i18n_t('必填'),
          type: 'error',
        },
        {
          validator: (val: number) => val >= 0 && val <= 65535,
          message: i18n_t('请输入0~65535之中的端口号'),
          type: 'error',
        },
      ],

      bindDN: [
        {
          required: true,
          message: i18n_t('必填'),
          type: 'error',
        },
      ],

      bindPassword: [
        {
          required: true,
          message: i18n_t('必填'),
          type: 'error',
        },
      ],

      searchDN: [
        {
          required: true,
          message: i18n_t('必填'),
          type: 'error',
        },
      ],

      loginFlag: [
        {
          required: true,
          message: i18n_t('必填'),
          type: 'error',
        },
      ],

      loginFlagShow: [
        {
          required: true,
          message: i18n_t('必填'),
          type: 'error',
        },
      ],

      departmentObjectclass: [
        {
          required: true,
          message: i18n_t('必填'),
          type: 'error',
        },
      ],

      userObjectclass: [
        {
          required: true,
          message: i18n_t('必填'),
          type: 'error',
        },
      ],
    };

    const methods = {
      init() {
        Object.assign(ldapFormData, props.initData);
        isChangePassword.value = false;
        methods.changeProtocol();
      },
      onClose() {
        innerShow.value = false;
      },
      changeProtocol() {
        if (isCreate.value) {
          ldapFormData.port = defaultPort[ldapFormData.protocol];
        }
        methods.throttleValidateConfigForm();
      },
      async testConfig() {
        const ldapForm = context.refs.ldapForm as any;
        const result = await ldapForm.validate();
        if (result === true) {
          methods.initLdapData(ldapFormData);
          context.emit('testConfig', { protocol: ldapFormData.type, config: ldapData });
        }
      },
      async saveConfig() {
        const ldapForm = context.refs.ldapForm as any;
        const result = await ldapForm.validate();
        if (result === true) {
          methods.initLdapData(ldapFormData);
          context.emit('saveConfig', { protocol: ldapFormData.type, config: ldapData });
        }
      },
      confirmRemove(type: string) {
        context.emit('removeProtocol', type);
        innerShow.value = false;
      },
      initLdapData(config: OpenLdapProtocolFormData) {
        const url = `${config.protocol}://${config.hostname}:${config.port}`;
        const { bindDN, bindPassword, searchDN, departmentObjectclass, userObjectclass, loginFlag, loginFlagShow } =
          config;
        // 密码base64处理(修改过才处理否则按照获取的密码原路返回)
        Object.assign(ldapData, {
          url,
          bindDN,
          bindPassword: isChangePassword.value ? encode(bindPassword) : bindPassword,
          searchDN,
          departmentObjectclass,
          userObjectclass,
          loginFlag,
          loginFlagShow,
        });
      },
      copyText(url: string) {
        copyText2Clipboard(url)
          .then(() => {
            tips.success(i18n_t('复制成功'));
          })
          .catch(() => {
            tips.success(i18n_t('复制失败'));
          });
      },
      changePassword() {
        if (!isChangePassword.value) {
          ldapFormData.bindPassword = '';
          isChangePassword.value = true;
        }
        methods.throttleValidateConfigForm();
      },
      rebackPassword() {
        if (ldapFormData.bindPassword === '') {
          ldapFormData.bindPassword = props.initData.bindPassword;
          isChangePassword.value = false;
        }
      },
      throttleValidateConfigForm: _.throttle(() => {
        const isDiff = Object.keys(props.initData).some(key => props.initData[key] !== ldapFormData[key]);
        if (isDiff) {
          context.emit('update:testResult', '');
        }
      }, 500),
    };

    watch(
      () => innerShow.value,
      val => {
        if (val) {
          methods.init();
        }
      },
    );

    return {
      innerShow,
      ldapOptions,
      ldapFormData,
      inputChange,
      canTest,
      isCreate,
      isChangePassword,
      showConfirm,
      rules,
      ...methods,
    };
  },
});
